import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/employee_pb';

import ApiEmployee from '@/model/Employee';

export default class Employee extends ApiEmployee {
  toGrpcModel(): pbm.Employee {
    return create(pbm.EmployeeSchema, {
      id: BigInt(this.id),
      name: this.name ?? '',
      order: BigInt(this.order),
    });
  }

  static fromApiModel(o: ApiEmployee) {
    const e = new Employee();
    e.id = o.id;
    e.name = o.name;
    e.order = o.order;
    return e;
  }
}
